import type { FaireProductEntity } from "../../entity_types/product";

export const p_yuvzd2mtn7: FaireProductEntity = {
  token: "p_yuvzd2mtn7",
  type: "product",
  name: "Super Duper Sugar Squisher Variety Kit /66 Pieces $5.00 each",
  brandToken: "b_1785c86e",
  brandName: "Top Trenz Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/d91366b9b80b53e50b40f14fe7e694d37a2f0ec980008361f8174d309fb973e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8aae5214e6b3f4af19d9ddc156b136d7ccb02b8c30e343a8d6d198b744e132b6.jpeg",
    "https://cdn.faire.com/fastly/ebd0db15ac76f90b83181c70c9074519e32d4ff0ada2909c7dd4ee4c23affd2c.png",
    "https://cdn.faire.com/fastly/24c2d8327d3098c32fa4585696b37619be1821ac397f72d817bfd4656d488e7b.jpeg",
    "https://cdn.faire.com/fastly/0fbce2f9ae956e1826107bf0cac1eaf2623822af50a6868f3374d3564bdbfb6c.jpeg",
    "https://cdn.faire.com/fastly/510cb0201f9e0aaa0d2bd381db6e9518268ff666bce127eb5e15bdd2c08e1cd6.jpeg",
    "https://cdn.faire.com/fastly/ed0aca55ab58b7288f190677cefbbfad7d89528b4e0c07120270c53e706ad0bb.jpeg",
    "https://cdn.faire.com/fastly/d96f91bcbed72a5ac491247ee62920f1782112947f0eea7202a0e0a3bfb6a4cc.jpeg",
    "https://cdn.faire.com/fastly/8477361b24b98e0a6698fa1db21ae8e26048aced8948bfa87ac527be04ae05b3.jpeg",
    "https://cdn.faire.com/fastly/cc6b74035494f8260df0aa685e2b0274ab42a18fc1d4614a2bd44b15e023973c.jpeg",
    "https://cdn.faire.com/fastly/1ab25a5c2460942e4030399bac87771e131ae4c4d4784dbfe6ace06bf0331f5f.jpeg",
    "https://cdn.faire.com/fastly/468071259274c7e29914cac53a3b640e36f5b0c3fe03588f309b29172b2d9ca1.jpeg",
    "https://cdn.faire.com/fastly/f263e55656d735ee80e3d4a7bb0d322ba8008909e1d38b54896630a35733aeab.jpeg",
    "https://cdn.faire.com/fastly/107d4d36ed4b0bb4a89496b2a02ee6585fbcbe80c9c8148b4a00c66245f3af6e.jpeg",
    "https://cdn.faire.com/fastly/2351a5821199a0805df1c2b5e0704c7fd7f87870130925255f108b35d1b92eee.jpeg",
    "https://cdn.faire.com/fastly/dcd208b7292480db761ffeb7129632a39915036e6f7f8cd14783ffde889fefd2.jpeg",
    "https://cdn.faire.com/fastly/5d83ef5f1d87676a278a6325724de76b873f918905e2768ee579bf37089dd50c.jpeg",
    "https://cdn.faire.com/fastly/1a72fe42ad91b60624aa8c2b84b46dd8e977a75449355a23a32662b6e08be173.jpeg",
  ],
  priceDollars: 330,
  description:
    "Introducing the Super Duper Sugar Squisher 66 Piece Starter Kit—the perfect way to experience our best selling Sugar line. See just how fantastic it is! This assortment features a mix of top designs. Each design comes in a variety of vibrant colors, with a cool-to-the-touch exterior and a thick, gel-like center that bounces back after every squeeze. \n\n\nSuper Duper Sugar Squisher Starter Kit - 66 pcs variety x  $5.00 each  + 1 display \n**Assorted colors & styles breakdown vary\n",
  tags: [],
  msrpDollars: 660,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:38.416Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
